import { FilterDataContext } from "providers/FilterData";
import { useContext } from "react";
import AdsSlot from "../Ads/Ads.Slot";
// import ClassiRecomend from "../ClassiRecomend";

const TemplateSideBarLeftPageWrapper = (props) => {
  const { items, policyId, renderItem } = props;
  const filterDataContext = useContext(FilterDataContext);
  const slotPolicyId =
    policyId.length > 0 ? policyId[0].replace("contentid/", "") : "";
  const slotData = filterDataContext.collections[slotPolicyId];

  const slotItemsFromProvider = slotData?.data || [];
  const itemsToRender = [...items, ...slotItemsFromProvider];
  const itemsToRenderLength = itemsToRender.length
    ? itemsToRender.length - 1
    : 0;
  const isLessThanTreeItems = itemsToRenderLength <= 2;
  
  return (
    <>
      {
        // FIXME rm classi
        itemsToRenderLength === 0 && null // && <ClassiRecomend />
      }
      {itemsToRender?.map((i, key) => {
        if (
          (isLessThanTreeItems && itemsToRenderLength === key) ||
          (!isLessThanTreeItems && key === 2)
        ) {
          return (
            <>
              <AdsSlot type="search" componentReference="top" data={i} />
              {renderItem({ item: i, position: key })}
              {/*<ClassiRecomend />*/}
              <AdsSlot type="search" componentReference="bottom" data={i} />
            </>
          );
        } else {
          return renderItem({ item: i, position: key });
        }
      })}
    </>
  );
};

export default TemplateSideBarLeftPageWrapper;
